import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-left-right', 'ArrowLeftRight', [["path",{"d":"M6.5 7.5h11M14 4l3.5 3.5L14 11m3.5 5.5h-11M10 13l-3.5 3.5L10 20","key":"svg-0"}]]);